const getComponent = (components, type) => components.find((c) => c.types.includes(type));

export const getPlace = (place, predictionText = null) => {
	const comps = place.addressComponents ?? [];

	const streetNumber = getComponent(comps, 'street_number');
	const route = getComponent(comps, 'route');
	const locality = getComponent(comps, 'locality');
	const sublocality = getComponent(comps, 'sublocality_level_1');
	const stateComp = getComponent(comps, 'administrative_area_level_1');
	const postalCode = getComponent(comps, 'postal_code');
	const countryComp = getComponent(comps, 'country');
	const subpremise = getComponent(comps, 'subpremise'); // unit/apartment
	const premise = getComponent(comps, 'premise'); // building name
	const floor = getComponent(comps, 'floor');

	let addressLine1 = '';

	// Use prediction text if provided (preserves "33a" format)
	if (predictionText) {
		// Extract just the first line from the prediction text
		// e.g., "33a Auckland St, Picton, New Zealand" -> "33a Auckland St"
		const firstLine = predictionText.split(',')[0]?.trim() ?? '';
		if (firstLine) {
			addressLine1 = firstLine;
		}
	}

	// Fall back to formattedAddress if predictionText didn't work
	if (!addressLine1) {
		const formattedAddress = place.formattedAddress ?? '';
		const formattedFirstLine = formattedAddress.split(',')[0]?.trim() ?? '';
		if (formattedFirstLine) {
			addressLine1 = formattedFirstLine;
		}
	}

	// Build from components as last resort
	if (!addressLine1) {
		const streetPart = [streetNumber?.longText, route?.longText].filter(Boolean).join(' ');
		addressLine1 = subpremise?.longText
			? `${subpremise.longText}/${streetPart}`
			: streetPart;
	}

	// if AU, set suburb as city/location / sublocality, if NZ, set suburb as sublocality / locatility/city
	const suburb = sublocality?.longText ?? locality?.longText;
	const city = locality?.longText;

	const state = stateComp?.shortText;
	const postcode = postalCode?.longText || '';
	const country = countryComp?.longText || '';

	const addressLine2 = [subpremise?.longText, premise?.longText, floor?.longText]
		.filter(Boolean)
		.join(', ');

	const addressLine3 = suburb || city;

	return {
		addressLine1,
		addressLine2,
		addressLine3,
		suburb,
		city,
		state,
		postcode,
		country,
		components: {
			streetNumber,
			route,
			locality,
			sublocality,
			state: stateComp,
			postalCode,
			countryComp,
			subpremise,
			premise,
			floor,
		},
	};
};
